webpackJsonp([70144966829960],{

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _screenReaderStyles = __webpack_require__(67);
	
	var _screenReaderStyles2 = _interopRequireDefault(_screenReaderStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A React component for the font-awesome icon library.
	 *
	 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
	 * @param {Boolean} [border=false] Whether or not to show a border radius
	 * @param {String} [className] An extra set of CSS classes to add to the component
	 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
	 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
	 * @param {String} [flip=false] Flip the icon's orientation.
	 * @param {Boolean} [inverse=false]Inverse the icon's color
	 * @param {String} name Name of the icon to use
	 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
	 * @param {Number} [rotate] The degress to rotate the icon by
	 * @param {String} [size] The icon scaling size
	 * @param {Boolean} [spin=false] Spin the icon
	 * @param {String} [stack] Stack an icon on top of another
	 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
	 * @module FontAwesome
	 * @type {ReactClass}
	 */
	var FontAwesome = function (_React$Component) {
	  _inherits(FontAwesome, _React$Component);
	
	  function FontAwesome() {
	    _classCallCheck(this, FontAwesome);
	
	    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));
	
	    _this.displayName = 'FontAwesome';
	    return _this;
	  }
	
	  _createClass(FontAwesome, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          border = _props.border,
	          cssModule = _props.cssModule,
	          className = _props.className,
	          fixedWidth = _props.fixedWidth,
	          flip = _props.flip,
	          inverse = _props.inverse,
	          name = _props.name,
	          pulse = _props.pulse,
	          rotate = _props.rotate,
	          size = _props.size,
	          spin = _props.spin,
	          stack = _props.stack,
	          _props$tag = _props.tag,
	          tag = _props$tag === undefined ? 'span' : _props$tag,
	          ariaLabel = _props.ariaLabel,
	          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);
	
	      var classNames = [];
	
	      if (cssModule) {
	        classNames.push(cssModule['fa']);
	        classNames.push(cssModule['fa-' + name]);
	        size && classNames.push(cssModule['fa-' + size]);
	        spin && classNames.push(cssModule['fa-spin']);
	        pulse && classNames.push(cssModule['fa-pulse']);
	        border && classNames.push(cssModule['fa-border']);
	        fixedWidth && classNames.push(cssModule['fa-fw']);
	        inverse && classNames.push(cssModule['fa-inverse']);
	        flip && classNames.push(cssModule['fa-flip-' + flip]);
	        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
	        stack && classNames.push(cssModule['fa-stack-' + stack]);
	      } else {
	        classNames.push('fa');
	        classNames.push('fa-' + name);
	        size && classNames.push('fa-' + size);
	        spin && classNames.push('fa-spin');
	        pulse && classNames.push('fa-pulse');
	        border && classNames.push('fa-border');
	        fixedWidth && classNames.push('fa-fw');
	        inverse && classNames.push('fa-inverse');
	        flip && classNames.push('fa-flip-' + flip);
	        rotate && classNames.push('fa-rotate-' + rotate);
	        stack && classNames.push('fa-stack-' + stack);
	      }
	
	      // Add any custom class names at the end.
	      className && classNames.push(className);
	      return _react2.default.createElement(tag, _extends({}, props, { 'aria-hidden': true, className: classNames.join(' ') }), ariaLabel ? _react2.default.createElement('span', { style: _screenReaderStyles2.default }, ariaLabel) : null);
	    }
	  }]);
	
	  return FontAwesome;
	}(_react2.default.Component);
	
	FontAwesome.propTypes = {
	  ariaLabel: _propTypes2.default.string,
	  border: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  cssModule: _propTypes2.default.object,
	  fixedWidth: _propTypes2.default.bool,
	  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  inverse: _propTypes2.default.bool,
	  name: _propTypes2.default.string.isRequired,
	  pulse: _propTypes2.default.bool,
	  rotate: _propTypes2.default.oneOf([90, 180, 270]),
	  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
	  spin: _propTypes2.default.bool,
	  stack: _propTypes2.default.oneOf(['1x', '2x']),
	  tag: _propTypes2.default.string
	};
	
	exports.default = FontAwesome;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  position: 'absolute',
	  width: '1px',
	  height: '1px',
	  padding: '0px',
	  margin: '-1px',
	  overflow: 'hidden',
	  clip: 'rect(0px, 0px, 0px, 0px)',
	  border: '0px'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	  }).join("&");
	}
	
	var ContactForm = function (_React$Component) {
	  _inherits(ContactForm, _React$Component);
	
	  function ContactForm(props) {
	    _classCallCheck(this, ContactForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      fetch("/", {
	        method: "POST",
	        headers: { "Content-Type": "application/x-www-form-urlencoded" },
	        body: encode(_extends({ "form-name": "contact" }, _this.state))
	      }).then(function () {
	        return _this.setState({ loaded: true });
	      }).catch(function () {
	        return _this.setState({ loaded: false });
	      });
	
	      e.preventDefault();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  ContactForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      "form",
	      {
	        id: "contactusform",
	        method: "post",
	        onSubmit: this.handleSubmit,
	        "data-netlify": "true",
	        "data-netlify-honeypot": "bot-field"
	      },
	      _react2.default.createElement("div", {
	        id: "success",
	        className: "no-margin-lr",
	        style: { display: "none" }
	      }),
	      _react2.default.createElement("input", {
	        name: "name",
	        type: "text",
	        required: "true",
	        placeholder: "Your Name",
	        onChange: this.handleChange
	      }),
	      _react2.default.createElement("input", {
	        name: "email",
	        type: "email",
	        placeholder: "Your Email",
	        required: "true",
	        onChange: this.handleChange
	      }),
	      _react2.default.createElement("textarea", {
	        placeholder: "Your Message",
	        required: "true",
	        name: "comment",
	        defaultValue: "",
	        onChange: this.handleChange
	      }),
	      _react2.default.createElement(
	        "button",
	        {
	          id: "contact-us-button",
	          type: "submit",
	          className: "highlight-button-dark btn btn-small button xs-margin-bottom-five",
	          disabled: this.state.loaded
	        },
	        this.state.loaded ? "Message Sent!" : "Send message"
	      )
	    );
	  };
	
	  return ContactForm;
	}(_react2.default.Component);
	
	exports.default = ContactForm;
	module.exports = exports["default"];

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      font-size: 22px;\n      margin-bottom: 16px;\n    "], ["\n      display: inline-block;\n      font-size: 22px;\n      margin-bottom: 16px;\n    "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      margin: 0 50px 0 0 !important;\n      &:last-child {\n        margin: 0 !important;\n      }\n    "], ["\n      margin: 0 50px 0 0 !important;\n      &:last-child {\n        margin: 0 !important;\n      }\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n      color: ", " !important;\n\n      &:hover {\n        color: ", " !important;\n      }\n    "], ["\n      color: ", " !important;\n\n      &:hover {\n        color: ", " !important;\n      }\n    "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FontAwesome = __webpack_require__(66);
	
	var SocialIcons = function (_Component) {
	  _inherits(SocialIcons, _Component);
	
	  function SocialIcons() {
	    _classCallCheck(this, SocialIcons);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SocialIcons.prototype.render = function render() {
	    var _this2 = this;
	
	    var socialData = [{
	      name: "facebook",
	      link: "https://www.facebook.com/Moon-Beyond-1683370475243357"
	    }, {
	      name: "twitter",
	      link: "https://twitter.com/moonbeyond_co/"
	    }, {
	      name: "instagram",
	      link: "https://www.instagram.com/moonbeyond/"
	    }, {
	      name: "tumblr",
	      link: "http://moon-beyond.tumblr.com/"
	    }];
	
	    var Wrap = _styledComponents2.default.div(_templateObject);
	
	    var SocialLink = _styledComponents2.default.a(_templateObject2);
	
	    var FontAwesomeIcon = (0, _styledComponents2.default)(FontAwesome)(_templateObject3, function (props) {
	      return _this2.props.light ? props.theme.colors.grey : props.theme.colors.black;
	    }, function (props) {
	      return _this2.props.light ? props.theme.colors.white : "";
	    });
	
	    return _react2.default.createElement(
	      Wrap,
	      null,
	      socialData.map(function (a, i) {
	        return _react2.default.createElement(
	          SocialLink,
	          { key: i, target: "_blank", href: a.link },
	          _react2.default.createElement(FontAwesomeIcon, { name: a.name })
	        );
	      })
	    );
	  };
	
	  return SocialIcons;
	}(_react.Component);
	
	exports.default = SocialIcons;
	module.exports = exports["default"];

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SocialIcons = __webpack_require__(52);
	
	var _SocialIcons2 = _interopRequireDefault(_SocialIcons);
	
	var _ContactForm = __webpack_require__(99);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var contactPage = function (_React$Component) {
	  _inherits(contactPage, _React$Component);
	
	  function contactPage() {
	    _classCallCheck(this, contactPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  contactPage.prototype.render = function render() {
	    var acf = this.props.data.wordpressPage.acf;
	
	
	    return _react2.default.createElement(
	      "div",
	      { className: "wow fadeIn", style: { visibility: "hidden" } },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Contact | Moon Beyond Co" }),
	      _react2.default.createElement(
	        "div",
	        { className: "wow fadeIn contactUsPage_container" },
	        _react2.default.createElement(
	          "div",
	          { className: "container-fluid" },
	          _react2.default.createElement(
	            "div",
	            { className: "row headingSection" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-xs-12 text-center headingContainer" },
	              _react2.default.createElement("div", { className: "separator-line bg-yellow no-margin-top margin-five" }),
	              _react2.default.createElement(
	                "h1",
	                { className: "white-text" },
	                acf.page_heading
	              ),
	              _react2.default.createElement(
	                "h2",
	                null,
	                acf.page_subheading
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "row contactForm" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 col-sm-6 text-left" },
	              _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: acf.contact_form_description } }),
	              _react2.default.createElement(
	                "div",
	                { className: "text-center" },
	                _react2.default.createElement(_SocialIcons2.default, { style: { textAlign: "center" } })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 col-sm-6 col-md-offset-2" },
	              _react2.default.createElement(_ContactForm2.default, null)
	            )
	          )
	        ),
	        _react2.default.createElement("img", {
	          className: "contactUsPage_image",
	          src: acf.image.localFile.childImageSharp.sizes.src
	        })
	      )
	    );
	  };
	
	  return contactPage;
	}(_react2.default.Component);
	
	exports.default = contactPage;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-55589b41a266a9844232.js